export class Trader {

  public password: string;
  public passwordRepeat: string;

  constructor(
    public hash?: string,
    public firstName?: string,
    public lastName?: string,
    public email?: string,
    public signatureLink?: string
  ) { }

  clone() {
    return new Trader(
      this.hash,
      this.firstName,
      this.lastName,
      this.email,
      this.signatureLink
    );
  }

  get fullName() {
    return `${ this.firstName } ${ this.lastName }`;
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/core/models/trader.ts